import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {REMIT_BASE_URL} from './config';

export interface AgentAccount {
  id: string;
  externalUserId: string;
  agentId: string;
  isDisabled?: boolean;
}

export interface AgentAccountView extends AgentAccount {
  username: string;
  agentName?: string;
}

export interface AgentAccountResponse {
  agentAccount: AgentAccount;
}

export interface CreateAgentAccountRequest {
  id?: string;
  username: string;
  password: string;
}

export interface AgentAccountsQueryRequest {
  pageNumber: number;
  pageSize: number;
  agentId?: string | null;
  agentIds?: string[] | null;
  externalUserId?: string | null;
  externalUserIds?: string[] | null;
  sortBy?: string | null;
  sortDirection?: 1 | -1 | null;
}

export interface AgentAccountsQueryResponse {
  body: AgentAccountView[];
  totalData: number;
}

export interface AgentAccountResetPasswordRequest {
  newPassword: string;
}

@Injectable({
  providedIn: 'root',
})
export class RemitAgentAccountService {
  private readonly agencyBase: string;

  constructor(
    private http: HttpClient,
    @Inject(REMIT_BASE_URL) private remitApiUrl: string,
  ) {
    this.agencyBase = `${this.remitApiUrl}/staff/agency`;
  }

  createAgentAccount(
      partnerId: string,
      payload: CreateAgentAccountRequest,
  ): Observable<AgentAccountResponse> {
    return this.http.post<AgentAccountResponse>(
        `${this.agencyBase}/partner/${partnerId}/account`,
        payload,
    );
  }

  queryAgentAccounts(
      payload: AgentAccountsQueryRequest,
  ): Observable<AgentAccountsQueryResponse> {
    return this.http.post<AgentAccountsQueryResponse>(
        `${this.agencyBase}/agent-accounts/query`,
        payload,
    );
  }

  getAgentAccount(
      partnerId: string,
      accountId: string,
  ): Observable<AgentAccountView> {
    return this.http.get<AgentAccountView>(
        `${this.agencyBase}/partner/${partnerId}/account/${accountId}`,
    );
  }

  resetPassword(
      partnerId: string,
      accountId: string,
      payload: AgentAccountResetPasswordRequest,
  ): Observable<AgentAccountResponse> {
    return this.http.post<AgentAccountResponse>(
        `${this.agencyBase}/partner/${partnerId}/account/${accountId}/reset-password`,
        payload,
    );
  }

  disableAgentAccount(
      partnerId: string,
      accountId: string,
  ): Observable<AgentAccountResponse> {
    return this.http.post<AgentAccountResponse>(
        `${this.agencyBase}/partner/${partnerId}/account/${accountId}/disable`,
        {},
    );
  }

  enableAgentAccount(
      partnerId: string,
      accountId: string,
  ): Observable<AgentAccountResponse> {
    return this.http.post<AgentAccountResponse>(
        `${this.agencyBase}/partner/${partnerId}/account/${accountId}/enable`,
        {},
    );
  }
}
